import React from "react";
import "../css/dotNetHeader.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { Pagination, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";

const DevelopersHeader = () => {
  const employeeList = [
    {
      id: 1,
      empImage: "/assets/blazordev.jpg",
      empName: "Qaiser Mehmood",
      empRole: "Senior Software Engineer",
    },
    {
      id: 2,
      empImage: "/assets/busman.jpg",
      empName: "Usman Ashraf",
      empRole: "Senior .NET Developer",
    },
    {
      id: 3,
      empImage: "/assets/randomUser.png",
      empName: "Ahmad Ali",
      empRole: "React .NET Developer",
    },
    {
      id: 4,
      empImage: "/assets/randomUser.png",
      empName: "Adeel Baig",
      empRole: ".NET Developer",
    },
    {
      id: 5,
      empImage: "/assets/randomUser.png",
      empName: "Anser Mehmood",
      empRole: ".Net Developer",
    },
    {
      id: 6,
      empImage: "/assets/randomUser.png",
      empName: "Zohaib Kashaf",
      empRole: "Python Developer",
    },
    {
      id: 7,
      empImage: "/assets/randomUser.png",
      empName: "Muhammad Asad",
      empRole: "Python Developer",
    },
  ];
  return (
    <div className="dotNetHeader">
      <div className="dotNetHeader-content">
        <h1 className="dotNetHeader_we">
          <span style={{ color: "#0F4C81" }}>Assemble Your Dream Team</span>
        </h1>
        <div className="dotNetHeader_create-section">
          <div className="dotNetHeader_content_para">
            In just 48 hours, you can access hidden gems of the IT world.
            Instead of relying on limited local talent, make use of talent
            outside your region.
          </div>
          <div className="developers_hire_btn">
            <Link to="/hire" className="dotnet_hire_btn">
              Hire a Developer
            </Link>
          </div>
        </div>
      </div>

      <Swiper
        pagination={{
          dynamicBullets: true,
        }}
        modules={[Pagination, Autoplay]}
        autoplay={true}
        className="dotNetHeader-image"
      >
        {employeeList.map((emp) => (
          <SwiperSlide key={emp.id}>
            <img src={emp.empImage} />
            <div className="person_name">{emp.empName}</div>
            <div className="person_role">{emp.empRole}</div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default DevelopersHeader;
